import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const Header = styled.h4`
  position: relative;
  margin: 0 40px 5px 0;
  padding: 0;
  ${TYPOGRAPHY.bodySemibold}
  line-height: 18px;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export default Header;
